function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "forum");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "forum"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.54,42.14a2.54,2.54,0,0,1-1.25-.33L32.83,34.67a2.5,2.5,0,1,1,2.48-4.34l8.73,5V32.41a2.5,2.5,0,0,1,5,0v7.23a2.49,2.49,0,0,1-2.5,2.5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.07,35H27.36A14,14,0,0,1,13.43,21.07V13.93A14,14,0,0,1,27.36,0H45.07A14,14,0,0,1,59,13.93v7.14A14,14,0,0,1,46.85,34.89a2.5,2.5,0,0,1-.63-5A9,9,0,0,0,54,21.07V13.93A9,9,0,0,0,45.07,5H27.36a8.94,8.94,0,0,0-8.93,8.93v7.14A8.94,8.94,0,0,0,27.36,30h6.71a2.5,2.5,0,0,1,0,5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.46,51.79a2.55,2.55,0,0,1-1.25-.34A2.51,2.51,0,0,1,10,49.29V42.05a2.5,2.5,0,0,1,5,0V45l8.73-5a2.5,2.5,0,1,1,2.48,4.34L13.71,51.46A2.54,2.54,0,0,1,12.46,51.79Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.64,44.64H24.93a2.5,2.5,0,1,1,0-5h4.71a8.87,8.87,0,0,0,8-4.94,2.5,2.5,0,0,1,4.47,2.24A13.85,13.85,0,0,1,29.64,44.64Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.47,44.55l-.32,0A14,14,0,0,1,0,30.71V23.57A14,14,0,0,1,13.93,9.64h2.14a2.5,2.5,0,0,1,0,5H13.93A8.94,8.94,0,0,0,5,23.57v7.14a8.93,8.93,0,0,0,7.78,8.86,2.5,2.5,0,0,1-.31,5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.21,24.75h-16a2.5,2.5,0,0,1,0-5h16a2.5,2.5,0,1,1,0,5Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.21,15.25h-16a2.5,2.5,0,0,1,0-5h16a2.5,2.5,0,0,1,0,5Z"
}))));

var SvgMessages = function SvgMessages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 59 51.79",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messages.46d35a0e.svg";
export { ForwardRef as ReactComponent };